export default "__VITE_ASSET__wg5Gw5am__"